import type { SVGProps } from "react";
import { memo } from "react";
const Keyspaces = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80" {...props}>
    <defs>
      <linearGradient id="prefix__a" x1="0%" x2="100%" y1="100%" y2="0%">
        <stop offset="0%" stopColor="#2E27AD" />
        <stop offset="100%" stopColor="#527FFF" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <path fill="url(#prefix__a)" d="M0 0h80v80H0z" />
      <path
        fill="#FFF"
        d="m68.024 29.02-3.221.756 2.521 2.828q-.282.56-.756.91a2.3 2.3 0 0 1-1.065.434l-1.959-3.388-1.96 3.388a2.3 2.3 0 0 1-1.065-.434 2.5 2.5 0 0 1-.756-.91l2.521-2.828-3.22-.756a2.4 2.4 0 0 1-.057-.448q0-.953.729-1.68l3.023 1.484-.391-3.612a2.8 2.8 0 0 1 1.176-.252q.644 0 1.175.252l-.391 3.612 3.023-1.484q.729.727.729 1.68 0 .168-.056.448M52.93 52.278q2.255 0 5.002-.902v1.927q-2.54 1.148-5.125 1.148-4.755 0-7.216-2.726-2.46-2.727-2.46-8.016 0-5.248 2.501-8.016 2.5-2.766 7.257-2.767 2.542 0 4.797.984v1.927a15 15 0 0 0-4.674-.738q-3.894 0-5.636 1.988-1.744 1.99-1.744 6.376v.492q0 4.264 1.764 6.294 1.763 2.03 5.534 2.029M31 13c10.767 0 18 3.103 18 6s-7.233 6-18 6c-10.642 0-17-3.051-17-6s6.358-6 17-6m18 49c0 2.897-7.233 6-18 6-8.357 0-17-2.244-17-6V51.883C16.973 54.44 23.075 56 31 56c4.092 0 7.981-.435 11.244-1.256l-.489-1.94C38.65 53.586 34.93 54 31 54c-8.357 0-17-2.23-17-5.963V37.8c3.001 2.584 9.168 4.2 17 4.2 4.088 0 7.977-.439 11.246-1.27l-.493-1.938C38.643 39.583 34.924 40 31 40c-10.642 0-17-3.051-17-6V22.8c3.001 2.584 9.168 4.2 17 4.2 7.258 0 14.578-1.468 18-4.304V26h2v-7c0-5.252-10.062-8-20-8-11.187 0-19 3.29-19 8v43c0 4.785 7.635 8 19 8 9.938 0 20-2.748 20-8v-2h-2z"
      />
    </g>
  </svg>
);
const Memo = memo(Keyspaces);
export default Memo;
